import Carousel from './Carousel';
import Swiper, { Scrollbar, Navigation, Keyboard } from 'swiper';
Swiper.use([Scrollbar, Navigation, Keyboard]);
import debounce from 'lodash.debounce';

export default class CarouselFeed extends Carousel {
	constructor(elm) {
		super(elm);

		this.boundCheckResize = debounce(this.checkResize.bind(this), 300);
		window.addEventListener('resize', this.boundCheckResize);

		this.breakpoint = window.matchMedia('(max-width: 768px)');

		if (this.breakpoint.matches === true) {
			this.init();
		}
	}

	init() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			scrollbar: {
				el: this.scrollbar,
				draggable: true,
				hide: false,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			slidesPerView: 1.2,
			spaceBetween: (window.innerWidth / 100) * 10,
			initialSlide: 0,
		});

		this.swiper.init();
	}

	destroy() {
		window.removeEventListener('resize', this.boundCheckResize);
		super.destroy();
	}

	destroySwiper() {
		this.swiper.destroy();
		this.swiper = null;
	}

	checkResize() {
		if (this.breakpoint.matches === true) {
			if (!this.swiper) {
				this.init();
			}
		} else {
			if (this.swiper) {
				this.destroySwiper();
			}
		}
	}
}
